var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"rowKey":function (row) { return row.name; },"data-source":_vm.list,"pagination":_vm.pagination},on:{"change":_vm.handlePagination}})}
var staticRenderFns = []

export { render, staticRenderFns }